'use es6';

import { NavMarker } from 'react-rhumb';
import { lang } from 'dashboard-lib/private/js-util';
import { capture } from 'dashboard-lib/public/sentry/report-management-sentry';
import { DASHBOARD_ERROR_BOUNDARY } from 'dashboard-lib/public/sentry/sentry-event-id';
import { createFingerprint } from 'dashboard-lib/public/sentry/sentry-fingerprint';
import PortalIdParser from 'PortalIdParser';
import FormattedMessage from 'I18n/components/FormattedMessage';
import GenericSplashMessage from 'dashboard-components/email/GenericSplashMessage';
import withErrorBoundary from './withErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
const errorLang = lang('errorState.dashboardRoute');
const DashboardErrorMessage = () => /*#__PURE__*/_jsx(NavMarker, {
  name: "DASHBOARD_LOAD_FAILED",
  children: /*#__PURE__*/_jsx(GenericSplashMessage, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: errorLang('title')
    }),
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: errorLang('description')
    })
  })
});
const onCatch = error => {
  capture(DASHBOARD_ERROR_BOUNDARY, {
    error,
    extra: {
      portalId: PortalIdParser.get()
    },
    fingerprint: createFingerprint(error)
  });
};
export default withErrorBoundary(onCatch, DashboardErrorMessage);